module.exports = __webpack_public_path__ + "img/bg-list.a2717f0d.png";